import React from "react";
import "./News.css";

const News = () => {
  return (
    <div className="news_parent_div">
      <h1>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dicta
        consectetur quia adipisci voluptatibus dolorem facere quam
        necessitatibus? Commodi, suscipit quia! Nulla sed iste quae reiciendis
        modi aperiam pariatur nesciunt sit?
      </h1>
    </div>
  );
};

export default News;
